import { ChangeDetectionStrategy, Component, signal, inject } from '@angular/core';
import { DemoUiService } from '../core/demo-ui.service';
@Component({ selector: 'rv-header', standalone: true, templateUrl: './header.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class HeaderComponent { readonly ui = inject(DemoUiService); readonly menuOpen = signal(false); readonly toggle = (value: boolean) => !value; }
